module.exports = __webpack_public_path__ + "static/media/28x153.41342e8e.png";